module.exports = __webpack_public_path__ + "static/media/Introduksjon-sprakforstaelse.04db15dd.mp3";